import { render, staticRenderFns } from "./SearchInsights.vue?vue&type=template&id=0270a7c0&"
import script from "./SearchInsights.vue?vue&type=script&lang=js&"
export * from "./SearchInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports